var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntersection3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 139,
    viewBox: "0 0 138 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M136.769 1.63326L137.911 2.77539L136.765 46.324L136.765 92.2187L137.911 135.745L136.758 136.898L135.604 138.051L92.0784 136.906L46.1836 136.906L2.63489 138.052L1.49275 136.91L0.350612 135.767L1.49663 92.2187L1.49663 46.324L0.350857 2.7846L1.49756 1.6379L2.64426 0.491203L46.1836 1.63698L92.0784 1.63698L135.627 0.490967L136.769 1.63326Z",
    fill: "url(#paint0_linear_259_17821)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_259_17821",
    x1: 1.75682,
    y1: 70.9745,
    x2: 138.455,
    y2: 67.9493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5219F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07C4FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntersection3);
export default __webpack_public_path__ + "static/media/intersection-3.3c0e16469f12033a42626b68214e608d.svg";
export { ForwardRef as ReactComponent };